import { TimetableReportType } from '@bp/planung-graphql-types';
import { Table, TableColumns } from '@bp/ui-components';
import { useState } from 'react';

export type TimetableReportTypesTableType = {
  type: TimetableReportType | null;
  name: string;
};

type TimetableReportTypesTableProps = {
  data: TimetableReportTypesTableType[];
  onSelect: (headline: string, type: TimetableReportType | null) => void;
};

export const TimetableReportTypesTable = ({ data, onSelect }: TimetableReportTypesTableProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const columns: TableColumns<TimetableReportTypesTableType>[] = [
    {
      header: '',
      id: 'name',
      accessorKey: 'name',
      canExpand: true,
    },
  ];

  return (
    <Table<TimetableReportTypesTableType>
      hideHeader
      data={data}
      columns={columns}
      onRowClick={(e, row) => {
        setSelectedIndex(parseInt(row.id));
        onSelect(row.original.name, row.original.type);
      }}
      showRowHover
      rowSelection={selectedIndex || selectedIndex === 0 ? { [selectedIndex]: true } : undefined}
      showSelected
      customPadding='var(--spacing-6)'
    />
  );
};
